import { Pipe, PipeTransform } from '@angular/core';
import { ChampLibre } from '../models/champLibre';

@Pipe({
  name: 'arretTabacStatut',
  standalone: true
})
export class ArretTabacStatutPipe implements PipeTransform {

  transform(arretTabac?: ChampLibre, ...args: unknown[]): 'success' | 'warning' | 'error' | 'info' {
    return arretTabac
      ? arretTabac.value == "OUI"
        ? 'success'
        : 'error'
      : 'warning'
  }

}
